import { Stack, Typography } from '@mui/material';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceTypesSelection } from './PriceTypesSelection';
import { PriceSuggestionType } from '@retail/products/types';

interface Props {
  priceSuggestionTypes: PriceSuggestionType[];
  checkedPriceTypes: PriceSuggestionType[];
  checkPriceType: (priceType: PriceSuggestionType) => void;
  getPriceTypeValue: (value: PriceSuggestionType) => string;
}

export function AvailablePriceSuggestions({
  priceSuggestionTypes,
  checkedPriceTypes,
  checkPriceType,
  getPriceTypeValue,
}: Props) {
  const t = usePriceSuggestionTFunction();
  return (
    <Stack minWidth="40%">
      <Stack height={50} justifyContent="center" bgcolor="grey.50">
        <Typography pl={2}>{t('priceSuggestion.availablePriceSuggestions')}</Typography>
      </Stack>
      <Stack px={4}>
        <PriceTypesSelection
          priceSuggestionTypes={priceSuggestionTypes}
          checkedPriceTypes={checkedPriceTypes}
          checkPriceType={checkPriceType}
          getPriceTypeValue={getPriceTypeValue}
        />
      </Stack>
    </Stack>
  );
}
